<template>
    <div>
        <a-card>
            <div class="m-5 p-5" v-if="answerList.length === 0 ">
                <a-empty>
                    <span slot="description">暂无答疑记录</span>
                </a-empty>
            </div>
            <table class="t3" v-if="answerList.length !== 0 ">
                <thead>
                <tr>
                    <td width="300">问题描述</td>
                    <td width="300">问题答复</td>
                    <td width="50">操作</td>
                </tr>
                </thead>
                <tbody>
                <template v-for="it in pageData">
                <tr >
                    <td>
                        <p class="mb-2 size1 color-ash">{{it.cmtTime}} <span style="float: right">{{it.cmtName}}</span></p>
                        <p class="color-black m-0 text-ellipsis-2">{{it.questionDesc}}</p>
                    </td>
                    <td class="color-main">
                        <p class="mb-2 size1 color-ash">{{it.answerTime}} <span style="float: right">{{it.answerName}}</span></p>
                        <p class="m-0">
                            <span v-if="it.status === 0" >暂无答复</span>
                            {{it.answerContent}}
                        </p>
                    </td>
                    <td>
                        <a-tag  class="mr-0" color="blue" @click="onDetails(it)">查看</a-tag>
                    </td>
                </tr>
                </template>
                </tbody>
            </table>
            <div class="text-right mt-5">
                <a-pagination @change="onChangePage" :defaultPageSize="5" :current="current"
                              :hideOnSinglePage="hideOnSinglePage"
                              :total="answerList.length"/>
            </div>
            <p class="mb-2 mt-5 size1" v-if="cmtPermission === 1">如未能及时收到答复，您也可以拨打项目经办人电话： {{bid.tenderTel}}   &nbsp;  {{bid.tenderOperator}} </p>
            <p class="mb-2 mt-5 size1" v-if="cmtPermission === 0">竞价开始前1天不再接受线上提问。如未能及时收到答复，您也可以拨打项目经办人电话：{{bid.tenderTel}}   &nbsp;  {{bid.tenderOperator}}</p>
            <div v-if="cmtPermission === 1">
                <a-form-item>
                    <a-textarea  :rows="4" v-model="content"  @keyup.enter.native="onsubmit()" />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="onsubmit" >
                        提交
                    </a-button>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <a-button  @click="onRefresh">
                        刷新
                    </a-button>
                </a-form-item>
            </div>
        </a-card>
        <AnswerDetails ref="asd" :visible="answerVisible" @cancel="cancel"></AnswerDetails>
    </div>
</template>


<script>
    import AnswerDetails from './AnswerDetails'
    import qs from "qs";
    import moment from "moment";
    export default {
        props:{
            projectId: {
                type:String,
                required: true
            },
            random: {
                type:String,
                default: '',
                required: false
            }
        },
        watch: {
            random: {
                immediate: false,
                handler(newValue,oldValue) {
                    if (newValue !== oldValue) {
                        // console.log("has listened data!")
                        this.initData();
                    }
                }
            }
        },
        components: {
            AnswerDetails
        },
        created() {
            this.initData();
        },
        name: "AnswerInfo",
        data() {
            return {
                answerList:[],
                answerVisible: false,
                content: '',
                current: 1,
                pageData:[],
                bid:'',
                hideOnSinglePage:true,
                openTime:0,
                cmtPermission: 1
            }
        },
        methods: {
            initData() {
                let that = this
                this.$http.get('/api/v1/reply/getList.json?projectId='+this.projectId).then(function (res) {
                    console.log(res)
                    that.answerList = res.result
                    that.bid = res.bid
                    that.onChangePage(1)
                    that.openTime = moment(res.bid.openTime).format('YYYY/MM/DD HH:mm:ss')
                    var openTimeYesterday = new Date(new Date(that.openTime).setHours(0, 0, 0, 0)) -24*60*60*1000
                    var current = new Date().getTime()
                    if (current > openTimeYesterday) {
                        that.cmtPermission = 0
                    }
                });
            },
            refresh(value) {
                this.projectId = value
                this.initData()
            },
            onDetails(it) {
                if (it.status === '0') {
                    this.$message.info("暂无答复")
                    return
                }
                this.$refs.asd.initData(it.id)
                this.answerVisible = true
            },
            cancel() {
                this.answerVisible = false
            },
            onRefresh() {
                let that = this
                this.$http.get('/api/v1/reply/getList.json?projectId='+this.projectId).then(function (res) {
                    that.answerList = res.result
                    // console.table(that.answerList)
                    that.onChangePage(1)
                });
            },
            onsubmit() {
                if (this.content.trim() === null || this.content.trim() === '') {
                    this.$message.error("提问内容不能为空");
                    return
                }
                if (this.content && this.content.length > 500) {
                    this.$message.error("提问内容不得超过500字!");
                    return
                }
                let params = {}
                params.questionDesc = this.content
                params.projectId = this.projectId
                this.content = ''
                let that = this
                this.$http.post('/api/v1/reply/add.json', qs.stringify(params)).then(function (res) {
                    if (res.code === 200) {
                        that.$message.info("提交成功!")
                        that.initData()
                    }
                })
            },
            onChangePage(current) {
                this.current = current
                // 获取索引
                var index = (this.current - 1) * 5
                this.pageData = []
                for (let i = index; i < index + 5; i++) {
                    var datum = this.answerList[i]
                    if (datum) {
                        this.pageData.push(datum)
                    }
                }
            }

        }
    }
</script>


<style scoped>
    .t3 {
        width: 100%;
        table-layout: fixed;
    }

    .t3 td {
        font-weight: 500;
        border-bottom: 1px solid #e6e6e6;
        padding: 12px 0;
        text-align: center;
        vertical-align: top;
    }

    .t3 thead td {
        color: #8c8c8c;

    }

    .t3 td:nth-last-child(1) {
        text-align: right;
    }
    .t3 td:nth-child(1) {
        padding: 12px 12px 12px 0;
        text-align: left;
    }
    .t3 tbody td:nth-child(1){
        border-right: 1px solid #e6e6e6;
    }
    .t3 td:nth-child(1) ,.t3 td:nth-child(2) {
        text-align: left;
        padding: 12px;
    }

</style>
